import {
	DndContext,
	DragEndEvent,
	DragOverlay,
	PointerSensor,
	TouchSensor,
	closestCenter,
	useSensor,
	useSensors,
} from '@dnd-kit/core';
import { SortableContext, rectSortingStrategy } from '@dnd-kit/sortable';
import {
	Table,
	TableBody,
	TableCell,
	TableContainer,
	TableHead,
	TableRow,
	styled,
} from '@mui/material';
import SortableArticlesItem from './SortableArticlesItem';
import { useTranslation } from 'react-i18next';

interface DndArticleListSectionProps {
	items: any;
	handleRepositionItem: (activeIndex: number, overIndex: number) => void;
}

export default function DndArticleListSection({
	items,
	handleRepositionItem,
}: DndArticleListSectionProps) {
	const { t } = useTranslation();

	// for input methods detection
	const sensors = useSensors(useSensor(PointerSensor), useSensor(TouchSensor));

	// triggered when dragging ends
	const handleDragEnd = (event: DragEndEvent) => {
		const { active, over } = event;
		if (!over) return;

		const activeItem = items.find((item: any) => item.id === active.id);
		const overItem = items.find((item: any) => item.id === over.id);

		if (!activeItem || !overItem) {
			return;
		}

		const activeIndex = items.findIndex((item: any) => item.id === active.id);
		const overIndex = items.findIndex((item: any) => item.id === over.id);

		if (activeIndex !== overIndex) {
			handleRepositionItem(activeIndex, overIndex);
		}
	};

	return (
		<DndContext
			sensors={sensors}
			collisionDetection={closestCenter}
			onDragEnd={handleDragEnd}
		>
			<SortableContext
				items={items.map((i: { id: any }) => i.id)}
				strategy={rectSortingStrategy}
			>
				<TableContainer>
					<Table>
						<TableHead>
							<TableRow
								sx={{
									backgroundColor: '#EEF1F6',
								}}
							>
								<StyledTableCell>{t('moment.exerciseTitleZh')}</StyledTableCell>
								<StyledTableCell>{t('moment.exerciseType')}</StyledTableCell>
								<StyledTableCell>{t('moment.seriesTitleZh')}</StyledTableCell>
								<StyledTableCell>{t('moment.seriesTime')}</StyledTableCell>
								<StyledTableCell>{t('moment.pushStatus')}</StyledTableCell>
								<StyledTableCell>{t('moment.lastUpdateTime')}</StyledTableCell>
								<StyledTableCell>{t('moment.createTime')}</StyledTableCell>
							</TableRow>
						</TableHead>
						<TableBody>
							{items?.map((item: any) => (
								<SortableArticlesItem key={item.id} item={item} />
							))}
						</TableBody>
					</Table>
				</TableContainer>
				<DragOverlay />
			</SortableContext>
		</DndContext>
	);
}

const StyledTableCell = styled(TableCell)({
	fontWeight: 'normal',
	minWidth: '160px',
});
